import { z } from "zod";

import { isPlausibleGraduationYear, requiredString, tzLocationField } from "./fields";

const requiredSelection = (message: string) =>
	z.union([requiredString(message), z.number()]).refine((value) => String(value).trim() !== "", message);

export const educationSchema = z.object({
	schoolName: requiredString("Please enter a school name"),
	schoolLocation: tzLocationField("Please enter a school location, it should follow the format City, Region"),
	educationLevel: requiredString("Please enter a certification"),
	fieldOfStudy: requiredString("Please enter what you studied"),
	fieldOfStudyCategory: requiredString("Please select a field of study"),
	gMonth: requiredSelection("Please select graduation month"),
	gYear: requiredSelection("Please enter graduation year").refine(
		isPlausibleGraduationYear,
		"Please enter a plausible graduation year",
	),
});

export type EducationFormValues = z.infer<typeof educationSchema>;
